module.exports = __webpack_public_path__ + "static/media/21ECLAC15.03148f01.jpg";